import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // getToken from cookie

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken() && JSON.parse(localStorage.getItem('userInfo'))) {
    if (to.path === '/login') {
      next({ path: '/' });
      NProgress.done();
    } else {
      if(JSON.parse(localStorage.getItem('isLogin')) === 1){
        JSON.stringify(localStorage.setItem('isLogin', 2))
        if(JSON.parse(localStorage.getItem('userInfo'))){
          
          store.dispatch('GenerateRoutes').then((addRouters) => {
            router.addRoutes(addRouters)
            next({...to, replace: true });
          })
        }

        setTimeout(() => {
          JSON.stringify(localStorage.setItem('isLogin', 1))
        }, 1);
      }
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login`)
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
